<script>
import $ from 'n-zepto'
import Utils from "@nat/heibao-utils";
export default {
  name: 'BaseVue',
  data () {
    return {
      APIHOST: location.protocol + '//enlighten.51talkjr.com/api/cms/',
      APPOINT_API: location.protocol + '//diviner.51talkjr.com/app_opt/',
      UNIT_KNOWLEDGE_API: location.protocol + '//enlighten.51talkjr.com/api/cms_application/',
      ENLIGHTEN_PREFIX: location.protocol + '//enlighten.51talkjr.com/',
      APIHOST_ORIGINAL: location.protocol + '//studybag.51talkjr.com/api/cms/',
      GATEWAY_ORIGINAL: '//igateway.51talkjr.com/textbook/',
	    // APPOINT_API_70: 'http://101.200.43.74:8181/app_opt/',
      // APIHOST: 'http://172.16.200.25:8000/api/cms/',
      // APIHOST: 'http://10.0.1.78:8123/api/cms/',
      // APIHOST: 'http://10.0.2.70:8124/api/cms/',
      // UNIT_KNOWLEDGE_API: 'http://10.0.2.70:8124/api/cms_application/',
      TIMEOUT: 3000,
      MAXWIDTH: document.body.offsetWidth,
      MAXHEIGHT: document.body.offsetWidth * 0.75,
      salt: '5l,o.v!e1'
    }
  },
  methods: {
    queryData: function (url, callback) {
      let lang = Utils.getQuery('metalang') || localStorage.getItem('currLang');
      if(url.indexOf('?')>=0) {
        url = `${url}&appkey=magic&timestamp=${new Date().getTime()}&metalang=${lang}`
      } else {
        url = `${url}?appkey=magic&timestamp=${new Date().getTime()}&metalang=${lang}`
      }
      var xhr = $.ajax({
        type: "GET",
        url: url,
        timeout: this.TIMEOUT,
        success: function (data) {
          if (typeof(data) === 'string') data = JSON.parse(data)
          if (data.error_code == 0) {
            return(callback(data.ret.data))
          }
          else{
            console.log('Error msg: ' + data.msg)
            console.log('Error message: ' + data.message)}
            return callback(data.ret)
        }
      })
    },
    resetVideoSize: function (url) {
      console.log('url: ' + url)
      let widthPattern = /width=\d+/
      let width = url.match(widthPattern)
      if (width == null) return(url)
      width = width[0].split('=')[1]
      let heightPattern = /height=\d+/
      let height = url.match(heightPattern)[0].split('=')[1]
      let newHeight = parseInt(this.MAXWIDTH / width * height * 100) / 100
      url = url.replace(widthPattern, 'width=' + this.MAXWIDTH).replace(heightPattern, 'height=' + newHeight)
      return url
    },
    addDiv: function (html){
      return '<div>' + html + '</html>'
    },
    isEmptyObject: function (obj) {
      return $.isEmptyObject(obj)
    },
    checkSig: function (str, sig){
      // check sha1 encrypt
      return this.generateSig(str) === sig;
    },
    generateSig: function (str) {
      // check sha1 encrypt
      let hash = sha1.create();
      hash.update(str + this.salt);
      return hash.hex()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseVue.vue